import gsap from 'gsap';

import 'gsap/src/uncompressed/utils/SplitText';

import Scrollbar from 'smooth-scrollbar';

import BezierEasing from 'bezier-easing';

import Component from '../base/component';
import { qs, qsa, byId } from '../base/dom-utils';
import { sortByData } from '../base/utils';
import Common from '../base/common';

const pageFramesIn = BezierEasing(0.31, 0.19, 0.16, 1);

class News extends Component {
    constructor(el, opts) {
        super(el, opts);

        this.$els.frames = qsa(this.options.frames, this.$el);
        this.$els.mainFrame = qs(this.options.mainFrame, this.$el);
        this.$els.posts = qsa(this.options.posts, this.$el);

        this.$els.scrollIco = byId(this.options.scrollIco);

        this._pieces = [];

        this.splitText = this.splitText.bind(this);

        this._scrollbar = Scrollbar.init(qs('[data-scrollbar]'));
    }

    beforeInit() {

        gsap.set(this.$els.scrollIco, {
            y: -40,
            opacity: 0
        });

        if (Common.mq('desktop') && !Modernizr.touchevents) {

            this.splitText();
            window.addEventListener('resize', this.splitText);

            const enteringEls = this.$els.posts.slice(1);

            enteringEls.forEach((element) => {

                gsap.set(element, {
                    y: 80,
                    autoAlpha: 0
                });

                gsap.set(qs(this.options.postTag, element), {
                    y: 40,
                    autoAlpha: 0
                });

                gsap.set(qs(this.options.postTitle, element), {
                    y: 40,
                    autoAlpha: 0
                });

            });

            this._scrollbar.addListener(() => {

                this.$els.posts.forEach((elem) => {

                    if (this._scrollbar.isVisible(elem)) {

                        const enterTl = new TimelineMax();

                        enterTl.to(elem, 0.65, {
                            y: 0,
                            autoAlpha: 1
                        })

                        .to(qs(this.options.postTag, elem), 0.35, {
                            y: 0,
                            autoAlpha: 1
                        }, '-=0.65')

                        .to(qs(this.options.postTitle, elem), 0.35, {
                            y: 0,
                            autoAlpha: 1
                        }, '-=0.35');

                    }

                });

            });

        }

    }

    splitText() {

        this._pieces.forEach((pie) => {
            pie.revert();
        });

        this._pieces.length = 0;

        this.$els.posts.forEach((element) => {

            const title = qs(this.options.postTitle, element);

            const splittedText = new SplitText(title, {
                type: 'lines',
                linesClass: 'c-post__pie',
                position: 'relative'
            });

            this._pieces.push(splittedText);
        });

    }

    animationIn() {

        const enterTl = new TimelineMax();

        const orderedFrames = sortByData(this.$els.frames);

        enterTl.staggerTo(orderedFrames.map((node) => node.children), 0.8, {
            y: 0,
            ease: new Ease(pageFramesIn)
        }, 0.05);

        if (Common.mq('s-tablet')) {

            enterTl.to(this.$els.mainFrame, 0.85, {
                y: 0,
                ease: new Ease(pageFramesIn)
            }, '-=0.6');

        }

        enterTl.to(this.$els.scrollIco, 0.5, {
            y: 0,
            opacity: 1
        });

    }

    destroy() {

        this._scrollbar.destroy();

        if (Common.mq('desktop') && !Modernizr.touchevents) {
            window.removeEventListener('resize', this.splitText);
        }

        return super.destroy();
    }

    getDefaultOptions() {
        return {
            frames: '.o-text__frame',
            mainFrame: '#main-frame',
            posts: '.c-post',
            postTitle: '.c-post__title',
            postTag: '.c-post__tag',
            scrollIco: 'scroll-down'
        };
    }
}

export default News;


/** WEBPACK FOOTER **
 ** ./containers/News.js
 **/